import { useEffect, useState } from "react";
import { staticImages } from "../../../modules/configs/appConfigs";
import * as styles from "./styles.module.scss";
import clsx from "../../../modules/helpers/clsx";
import LoadingSpinner from "./LoadingSpinner";

interface IProps {
  loadingText: string;
}

const FullPageLoading = (props: IProps) => {
  const [showHelper, setShowHelper] = useState<boolean>(false);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowHelper(true);
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className={styles.fullPageContainer}>
      <LoadingSpinner size={64} />
      <img src={staticImages.logo} alt="Logo" className={styles.logo} />
      <div
        className={clsx({
          [styles.loadingText]: true,
          [styles.fade]: !showHelper,
        })}
      >
        {props.loadingText}
      </div>
    </div>
  );
};

export default FullPageLoading;
